module.exports = __webpack_public_path__ + "f707818262a6beece4f7017d6939e3dc.png";